import { io } from 'socket.io-client';
import { store } from '../store';
import { agentUpdated, agentAdded, agentRemoved } from '../store/agentsSlice';
import { listenerUpdated } from '../store/listenersSlice';
import { taskUpdated, taskAdded } from '../store/tasksSlice';
import { showToast } from '../components/ToastNotification';

const SOCKET_URL = process.env.REACT_APP_SOCKET_URL || '';

class SocketService {
  constructor() {
    this.socket = null;
    this.agentsSocket = null;
    this.tasksSocket = null;
    this.listenersSocket = null;
  }

  connect() {
    const token = localStorage.getItem('token');
    if (!token) return;

    // Main socket
    this.socket = io(SOCKET_URL, {
      transports: ['websocket'],
      autoConnect: true,
    });

    this.socket.on('connect', () => {
      console.log('Socket connected');
      this.socket.emit('authenticate', { token });
    });

    this.socket.on('authenticated', (data) => {
      console.log('Socket authenticated:', data);
    });

    this.socket.on('disconnect', () => {
      console.log('Socket disconnected');
    });

    // Agents namespace
    this.agentsSocket = io(`${SOCKET_URL}/agents`, {
      transports: ['websocket'],
    });

    this.agentsSocket.on('agent_registered', (agent) => {
      store.dispatch(agentAdded(agent));
      showToast(`New agent registered: ${agent.hostname || agent.agent_id}`, 'agent');
    });

    this.agentsSocket.on('agent_beacon', (data) => {
      store.dispatch(agentUpdated(data));
    });

    this.agentsSocket.on('agent_removed', (data) => {
      store.dispatch(agentRemoved(data));
      showToast(`Agent removed: ${data.agent_id}`, 'warning');
    });

    this.agentsSocket.on('activity', (data) => {
      showToast(data.message, data.type === 'persistence_installed' ? 'warning' : 'info');
    });

    // Tasks namespace
    this.tasksSocket = io(`${SOCKET_URL}/tasks`, {
      transports: ['websocket'],
    });

    this.tasksSocket.on('task_created', (task) => {
      store.dispatch(taskAdded(task));
    });

    this.tasksSocket.on('task_completed', (task) => {
      store.dispatch(taskUpdated(task));
      if (task.status === 'completed') {
        showToast(`Task completed: ${task.task_type}`, 'success');
      } else if (task.status === 'failed') {
        showToast(`Task failed: ${task.task_type}`, 'error');
      }
    });

    // Listeners namespace
    this.listenersSocket = io(`${SOCKET_URL}/listeners`, {
      transports: ['websocket'],
    });

    this.listenersSocket.on('listener_started', (listener) => {
      store.dispatch(listenerUpdated(listener));
    });

    this.listenersSocket.on('listener_stopped', (listener) => {
      store.dispatch(listenerUpdated(listener));
    });
  }

  disconnect() {
    if (this.socket) this.socket.disconnect();
    if (this.agentsSocket) this.agentsSocket.disconnect();
    if (this.tasksSocket) this.tasksSocket.disconnect();
    if (this.listenersSocket) this.listenersSocket.disconnect();
  }

  subscribeToAgent(agentId) {
    if (this.agentsSocket) {
      this.agentsSocket.emit('subscribe_agent', { agent_id: agentId });
    }
  }

  unsubscribeFromAgent(agentId) {
    if (this.agentsSocket) {
      this.agentsSocket.emit('unsubscribe_agent', { agent_id: agentId });
    }
  }
}

export const socketService = new SocketService();
export default socketService;
